import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
  selector: 'text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
